import './pageLoader.css';

interface PageLoaderProps {
    variant?: 'rounded' | 'skeleton';
    inContainer?: boolean;
}

const PageLoader: React.FC<PageLoaderProps> = ({
    variant = 'rounded',
    inContainer = false,
}) => {
    return (
        <div
            className={`page-loader-overlay ${
                inContainer ? 'in-container' : ''
            }`}
        >
            <div className="page-loader">
                {variant === 'skeleton' ? (
                    <>
                        <div className="skeleton-card" />
                        <div className="skeleton-row" />
                        <div className="skeleton-row short" />
                    </>
                ) : (
                    <div className="rounded-loader" />
                )}
            </div>
        </div>
    );
};

export default PageLoader;
